import { GameEventCommandKinds } from '../GameEventCommandKinds'
import { GameCommand } from './GameCommand'

export class ProcessableGameEventComamnd {
  private _partitionKey: string
  private _kind: GameEventCommandKinds

  constructor(
    public command: GameCommand,
    public gameId: string,
    kind: GameEventCommandKinds
  ) {
    this._partitionKey = gameId
    this._kind = kind
  }

  get partitionKey() {
    return this._partitionKey
  }

  get kind() {
    return this._kind
  }
}
